import React from 'react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';

const TitleRow = () => (
  <GridTableRow variant="header">
    <GridTableCell>Name</GridTableCell>
    <GridTableCell>Description</GridTableCell>
    <GridTableCell />
  </GridTableRow>
);

export { TitleRow };
